var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacepetenegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 413,
    height: 600,
    viewBox: "0 0 413 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__c",
    d: "M0 145.425C0 65.11 65.113 0 145.422 0c80.314 0 145.422 65.103 145.422 145.425v32.073c0 66.273-53.727 119.998-120.003 119.998h-50.838C53.727 297.496 0 243.772 0 177.498v-32.073z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__e",
    d: "M243.75 81l44.904 111.955 8.608-91.213c3.062-32.442-19.168-68.065-50.266-77.8 0 0-163.576-75.215-236.074 42.058 0 0-29.719 36.405 10.076 47.271l2.43 60.203 18.596-38.937S219.632 118.427 243.75 81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__g",
    d: "M241.503 90.345l44.15 100.61 1.404-87.861c.521-32.579-23.512-68.947-54.389-79.353 0 0-154.008-76.817-226.507 40.456 0 0-17.956 37.939 21.838 48.805v41.153l27.634-43.718s161.752 17.335 185.87-20.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__i",
    d: "M.202 18.63C.202 8.34 8.535 0 18.83 0H77.6c10.288 0 18.029 8.31 17.288 18.581L93.498 37.83c-1.5 20.785-19.607 37.635-40.441 37.635h-15.13C17.093 75.464.203 58.575.203 37.732V18.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__k",
    d: "M0 18.63C0 8.34 8.333 0 18.629 0h58.768c10.288 0 18.029 8.31 17.288 18.581L93.296 37.83c-1.5 20.785-19.607 37.635-40.44 37.635h-15.13C16.89 75.464 0 58.575 0 37.732V18.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__m",
    d: "M53.578 24.61c1.589-1.397 2.207-4.707 1.382-7.395-.826-2.687-2.784-3.734-4.373-2.337L2.107.216C.52 1.612-.1 4.923.727 7.61c.825 2.687 2.783 3.734 4.372 2.337l48.48 14.662z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_pete_negative_svg__n",
    d: "M5.36 14.335c-1.59-1.406-3.547-.344-4.37 2.372-.824 2.716-.202 6.058 1.388 7.464L36.332 9.948c1.59 1.406 3.547.344 4.37-2.372.824-2.716.202-6.058-1.389-7.464L5.36 14.335z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "face_pete_negative_svg__a",
    width: 64,
    height: 131.697,
    x: 0.425,
    y: 0.89,
    rx: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(27 21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.512,
    cy: 228.249,
    fill: "#E9BEA9",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.481,
    cy: 231.171,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.031,
    cy: 228.249,
    fill: "#E9BEA9",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 228.171,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.575 281.65)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_pete_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_pete_negative_svg__a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 76.6,
    height: 144.297,
    x: -5.875,
    y: -5.41,
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 38.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 206.391,
    x: -17.575,
    y: -52.182,
    fill: "#E9BEA9",
    mask: "url(#face_pete_negative_svg__b)",
    rx: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M10.566 57.35S-3.148 91.398 32.28 109.318c35.427 17.92-22.546 28.412-22.546 28.412l-31.167-41.852-1.142-33.152 33.141-5.376z",
    mask: "url(#face_pete_negative_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.995 54.29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_pete_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_pete_negative_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#face_pete_negative_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9BEA9",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M145.447 6.3c38.408.007 73.18 15.577 98.35 40.748 25.176 25.176 40.747 59.957 40.747 98.377h0v32.073c0 31.396-12.727 59.82-33.303 80.396-20.576 20.576-49.002 33.302-80.4 33.302h0-50.838c-31.399 0-59.824-12.726-80.4-33.302-20.577-20.575-33.303-49-33.303-80.396h0v-32.073c0-38.001 15.237-72.444 39.933-97.553C70.966 22.726 105.187 6.94 143.094 6.32h0z",
    mask: "url(#face_pete_negative_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "134.261 254.946 154.261 254.946 144.261 264.871",
    mask: "url(#face_pete_negative_svg__d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.951,
    cy: 30.884,
    fill: "#000",
    fillOpacity: 0.05,
    mask: "url(#face_pete_negative_svg__d)",
    rx: 145.422,
    ry: 46.011
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M295.612 150.21s-63.214 132.726-153.364 156.91l111.882-42.327 49.24-83.192-2.561-24.127-5.197-7.263z",
    mask: "url(#face_pete_negative_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M262.57 146.187c-6.265-10.852-23.549-12.604-38.604-3.912M98.555 159.467c9.6-8.055 26.44-3.79 37.614 9.528"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 338 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_pete_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_pete_negative_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M5.737 62.408c72.788-117.219 234.488-48.319 243.5-44.364 16.63 5.313 30.976 17.358 40.774 32.522 9.979 15.444 15.195 34.057 13.524 51.768h0l-11.052 117.093L241.494 92.3c-38.348 29.97-171.667 45.572-195.304 48.133h0l-28.031 58.693-3.277-81.168c-38.304-13.6-12.32-51.177-9.145-55.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M5.737 62.408c72.788-117.219 234.488-48.319 243.5-44.364 16.63 5.313 30.976 17.358 40.774 32.522 9.979 15.444 15.195 34.057 13.524 51.768h0l-11.052 117.093L241.494 92.3c-38.348 29.97-171.667 45.572-195.304 48.133h0l-28.031 58.693-3.277-81.168c-38.304-13.6-12.32-51.177-9.145-55.55z",
    mask: "url(#face_pete_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#664C3C",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M122.669 196.681c15.39-7.506 16.005-37.91 1.373-67.91h0c-14.632-30-38.97-48.233-54.359-40.727M166.736 176.512c15.39-7.506 16.005-37.91 1.373-67.91h0c-14.632-30-38.969-48.234-54.359-40.728M204.508 151.3c15.39-7.506 16.005-37.91 1.373-67.91h0c-14.632-29.999-38.969-48.233-54.359-40.727",
    mask: "url(#face_pete_negative_svg__f)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "53.78 96.5 18.871 115.398 17.03 194.711 40.26 158.973",
    mask: "url(#face_pete_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M212.17 80.883s25-15 32-35c4.157 29-32 35-32 35z",
    mask: "url(#face_pete_negative_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 167.5 213)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_pete_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_pete_negative_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M.71 61.035C73.532-56.762 226.04 13.605 235.064 17.902c16.357 5.625 30.99 17.908 41.486 33.223 10.728 15.651 17.09 34.396 16.807 52.07h0l-1.866 116.742-52.015-118.534c-11.752 8.907-32.182 14.447-56.137 17.042-47.812 5.179-108.2.176-124.28-1.339h0L21.7 175.778v-58.144C-19.12 103.22.467 61.502.467 61.502s.01-.023.033-.068l.06-.118c.038-.073.087-.167.15-.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M95.287-4.486c63.025-11.553 127.441 16.607 138.449 21.755h0l.93.439c16.758 5.821 31.388 18.103 41.884 33.417 10.728 15.651 17.09 34.396 16.807 52.07h0l-1.866 116.742-52.006-118.515c-10.36 7.895-27.46 13.174-47.9 16.008-36.314 5.036-82.425 3.311-110.729 1.416h0l-3.636-.25c-1.184-.084-2.33-.168-3.437-.251h0l-3.174-.244-1.51-.12h0l-2.797-.23-2.527-.216-2.24-.2-1.935-.177-.719-.069-37.182 58.824v-58.29C10.46 113.606 3.973 107.39.242 100.758-6.078 89.52-4.334 76.46-2.074 68.542h0l.278-.944.285-.911.28-.848.27-.78.26-.712.242-.64.23-.587.588-1.407C25.69 20.363 60.299 1.928 95.287-4.486z",
    mask: "url(#face_pete_negative_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#664C3C",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M119.669 194.681c15.39-7.506 16.005-37.91 1.373-67.91h0c-14.632-30-38.97-48.233-54.359-40.727M163.736 174.512c15.39-7.506 16.005-37.91 1.373-67.91S126.14 58.368 110.75 65.874M201.508 149.3c15.39-7.506 16.005-37.91 1.373-67.91h0c-14.632-29.999-38.969-48.233-54.359-40.727",
    mask: "url(#face_pete_negative_svg__h)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M22.5 113.398L60.623 115 47.26 156.973 24.03 192.71l-1.53-79.313zM255.666 55c4.157 29-32 35-32 35l.118-.071.143-.089c2.674-1.658 25.16-16.04 31.74-34.84z",
    mask: "url(#face_pete_negative_svg__h)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.409,
    cy: 183.037,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M130.388 288.235c0-7.18 23.967-13 53.531-13h0c29.565 0 53.531 5.82 53.531 13"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.171,
    cy: 183.037,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.409,
    cy: 183.037,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M163.238 241.418c0 9.767 7.908 17.684 17.663 17.684h0c9.755 0 17.663-7.917 17.663-17.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M179.5 217a8.5 8.5 0 017.487 12.528c4.751 2.381 8.013 7.296 8.013 12.972 0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5c0-5.068 2.6-9.529 6.539-12.121A8.5 8.5 0 01179.5 217z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M25.814 220.827c5.371-3.227 12.338-1.495 15.561 3.87h0c3.223 5.364 1.483 12.329-3.888 15.556M319.129 222.788c4.728-4.11 11.89-3.614 15.996 1.109h0c4.106 4.723 3.6 11.884-1.128 15.995"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.171,
    cy: 183.037,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.198,
    cy: 241.892,
    fill: "#DB8A8A",
    opacity: 0.3,
    rx: 17.778,
    ry: 17.777
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.266,
    cy: 241.892,
    fill: "#DB8A8A",
    opacity: 0.3,
    rx: 17.778,
    ry: 17.777
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.22 190.596)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.655 .044)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_pete_negative_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_pete_negative_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A46B",
    fillOpacity: 0.5,
    stroke: "#363A4F",
    strokeWidth: 9.801,
    d: "M77.599 4.9c3.69 0 6.944 1.46 9.194 3.88 2.25 2.417 3.472 5.766 3.206 9.449h0L88.61 37.476c-.659 9.137-4.99 17.394-11.42 23.377-6.43 5.983-14.975 9.71-24.133 9.71h0-15.13c-9.064 0-17.27-3.674-23.211-9.615-5.94-5.94-9.614-14.148-9.614-23.216h0V18.63c0-3.792 1.536-7.225 4.02-9.71A13.683 13.683 0 0118.83 4.9h0z",
    mask: "url(#face_pete_negative_svg__j)",
    transform: "matrix(-1 0 0 1 95.138 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M30.503 65.786s60.751-33.322 82.308-86.245c21.556-52.922 9.798 107.806 9.798 107.806H40.302l-9.799-21.561z",
    mask: "url(#face_pete_negative_svg__j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.051 .044)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_pete_negative_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_pete_negative_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A46B",
    fillOpacity: 0.5,
    stroke: "#363A4F",
    strokeWidth: 9.801,
    d: "M77.397 4.9c3.69 0 6.944 1.46 9.194 3.88 2.25 2.417 3.472 5.766 3.206 9.449h0l-1.389 19.247c-.659 9.137-4.99 17.394-11.42 23.377-6.43 5.983-14.975 9.71-24.133 9.71h0-15.13c-9.064 0-17.27-3.674-23.211-9.615C8.574 55.008 4.9 46.8 4.9 37.732h0V18.63c0-3.792 1.535-7.225 4.02-9.71a13.683 13.683 0 019.708-4.02h0z",
    mask: "url(#face_pete_negative_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M39.063 71.777s31.486-8.161 53.043-61.084-10.26 48.556-10.26 48.556l-25.22 10.28-17.563 2.248z",
    mask: "url(#face_pete_negative_svg__l)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 91.41,
    x2: 115.978,
    y1: 25.707,
    y2: 25.707,
    stroke: "#363A4E",
    strokeLinecap: "square",
    strokeWidth: 12.6
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#363A50",
    fillRule: "nonzero",
    transform: "translate(274.376 200)",
    xlinkHref: "#face_pete_negative_svg__m"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#363A50",
    fillRule: "nonzero",
    transform: "translate(42 201)",
    xlinkHref: "#face_pete_negative_svg__n"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacepetenegative);
export default __webpack_public_path__ + "static/media/face.pete.negative.e1b45758.svg";
export { ForwardRef as ReactComponent };